export function licenseActive(user) {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (user.is_active === false) return false;
  if (user.access_until) {
    const end = new Date(user.access_until + "T23:59:59");
    return end.getTime() >= Date.now();
  }
  return true;
}

export function daysLeft(user) {
  if (!user || !user.access_until || user.role === "admin") return null;
  const end = new Date(user.access_until + "T23:59:59");
  return Math.ceil((end.getTime() - Date.now()) / (1000 * 60 * 60 * 24));
}
